module.exports = __webpack_public_path__ + "static/media/banner4.89a54338.png";